"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReduxTextField;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireWildcard(require("react"));
var _uuid = require("uuid");
var _utils = require("../../../utils");
var _excluded = ["defaultValue", "helperText", "hideIfEmpty", "id", "input", "InputLabelProps", "meta", "notNull", "type"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function () {});
function ReduxTextField(_ref) {
  var defaultValue = _ref.defaultValue,
    helperText = _ref.helperText,
    hideIfEmpty = _ref.hideIfEmpty,
    id = _ref.id,
    input = _ref.input,
    InputLabelProps = _ref.InputLabelProps,
    _ref$meta = _ref.meta,
    _ref$meta2 = _ref$meta === void 0 ? {} : _ref$meta,
    active = _ref$meta2.active,
    autofilled = _ref$meta2.autofilled,
    modifiedSinceLastSubmit = _ref$meta2.modifiedSinceLastSubmit,
    inputError = _ref$meta2.error,
    touched = _ref$meta2.touched,
    warning = _ref$meta2.warning,
    _ref$meta2$data = _ref$meta2.data,
    data = _ref$meta2$data === void 0 ? {} : _ref$meta2$data,
    notNull = _ref.notNull,
    type = _ref.type,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // Only here to force rerender on theme change
  // eslint-disable-next-line no-unused-vars
  var classes = useStyles();
  var componentIdState = (0, _react.useState)(id || (0, _uuid.v4)());
  var _useState = (0, _react.useState)('transparent'),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    backgroundColor = _useState2[0],
    setBackgroundColor = _useState2[1];
  var _ref2 = props || {},
    variant = _ref2.variant;
  var error = inputError || !modifiedSinceLastSubmit && data.submitError;
  (0, _react.useEffect)(function () {
    if (!error && input.value === '' && type !== 'number' && !notNull && input.value !== null) {
      input.onChange(null);
    }
  }, [error, input, type, notNull]);
  (0, _react.useEffect)(function () {
    // if brauser autofills we will lose label bg also (is filled with autofill color), need to restore it
    // from parent component
    var color = function () {
      var el = document.getElementById(componentIdState[0]);
      if (el != null && el.parentElement) {
        return (0, _utils.getBgColor)(el.parentElement);
      }
      return 'transparent';
    }();
    setBackgroundColor(color);
  }, [componentIdState]); // force re-render

  if (hideIfEmpty && input.value === '') {
    return false;
  }
  var outlined = variant === undefined || variant === 'outlined';
  var shrink = active || autofilled || !!input.value || input.value === 0;
  return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({
    variant: "outlined"
  }, input, props, {
    error: Boolean(touched && (error || warning)),
    helperText: touched && (error || warning) || helperText,
    id: componentIdState[0],
    InputLabelProps: (0, _extends2.default)({
      shrink
    }, InputLabelProps, {
      style: (0, _extends2.default)({}, InputLabelProps == null ? void 0 : InputLabelProps.style, outlined && shrink && {
        backgroundColor
      })
    }),
    type: type
  }));
}